import { IOrderHeader, RoleColor } from "../../interface/IOrders_Tasks";

export type OrdersHeader = IOrderHeader[];


export const roleColor: RoleColor[] = [
  {
    roleName: 'Picker',
    color: 'lightgreen'
  },
  {
    roleName: 'Packer',
    color: 'cyan'
  },
  {
    roleName: 'QC',
    color: 'orange'
  },
  {
    roleName: 'Shipper',
    color: 'lightBlue'
  },
  {
    roleName: 'Administrator',
    color: 'grey'
  },
]
